module.exports = __webpack_public_path__ + "img/hotel15.d05f471b.png";